import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`
export const BottomBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    height: 33px;
    /* justify-content: center; */
    align-items: center;
    //margin: 0 -0.5rem;
    & > div {
        flex: 1 1 auto;
    }

    & > button {
        padding: 2px;
        height: 100%;
        width: 100px;
    }
`
